import React, { useState, useRef, useEffect } from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';
import colors from '../../theme/colors';


const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: colors.primary,
        borderRadius: '10px',
        color: 'white',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(16),
        border: '1px solid ' + colors.textMain,
        padding: '1em'
    },
    arrow: {
        "&:before": {
            border: "1px solid " + colors.textMain
        },
        color: theme.palette.common.white
    }
}));

export function TooltipButton({ children, titulo, body }) {

    useEffect(() => {
        // ComponentDidMount y ComponentWillUnmount
        return () => {
            clearTimeout(leaveTimer); // Limpia el timer cuando el componente se desmonta
        };
    }, []);
    const [open, setOpen] = useState(false);
    let leaveTimer;

    const handleMouseEnter = () => {
        clearTimeout(leaveTimer); // Limpia el timer cuando entras al bot�n
        setOpen(true);
    };

    const handleMouseLeave = () => {
        // Establece un retraso antes de cerrar el tooltip para dar tiempo al usuario de moverse entre tooltips
        leaveTimer = setTimeout(() => {
            setOpen(false);
        }, 0); // Este retraso puede ser ajustado si es necesario
    };

    return (
        <HtmlTooltip
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
                <Stack gap={1}>
                    <Typography variant='parrafoLigth' fontWeight={'bold'}>{titulo}</Typography>
                    <Typography variant='parrafoLigth'>{body}</Typography>
                </Stack>
            }
        >
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                {React.cloneElement(children)}
            </div>
        </HtmlTooltip>
    );
}
